import React from "react";
import { Outlet } from "react-router-dom";
import PublicSiteNav from "components/PublicSiteNav";
import SiteHeaderBanner, {
  siteHeaderBannerOffsetRem,
} from "components/SiteHeaderBanner";
import useSiteHeaderMessages from "hooks/useSiteHeaderMessages";

/**
 * Wraps public marketing pages with the fixed top navigation.
 * Padding zone uses the same navy as pages (#0B1437) so body background never shows as a gray band.
 */
export default function PublicSiteLayout() {
  const { messages } = useSiteHeaderMessages("public");
  const bannerRem = siteHeaderBannerOffsetRem(messages.length);

  return (
    <>
      <div className="fixed inset-x-0 top-0 z-50">
        <SiteHeaderBanner messages={messages} />
        <PublicSiteNav stacked />
      </div>
      <div
        className="bg-[#0B1437] pt-[calc(6.5rem+var(--banner-offset))] sm:pt-[calc(7.5rem+var(--banner-offset))]"
        style={{ "--banner-offset": `${bannerRem}rem` }}
      >
        <Outlet />
      </div>
    </>
  );
}
